import React, { useEffect, useState } from 'react';
import logo from '../logo.png';
import '../App.css';
import '../style/Header.css'; 
import { useUser } from '../context/UserContext';
import { useUserLogin } from '../context/AuthContext';
import { Link , useNavigate } from 'react-router-dom';
import { logout, testApp } from '../types/authService';
import UserProfile from './user/UserProfile';
interface Image {
  src: string;
  alt: string;
}

const images: Image[] = [
  //{ src: require('../images/slide/s1.jpg'), alt: 'Image 1' },
  //{ src: require('../images/slide/s2.jpg'), alt: 'Image 2' }
  // Add your image sources here if needed
];

const Header: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { user } = useUser(); 
  //const { userLogin } = useUserLogin();
  const {setUserLogin } = useUserLogin();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  //const location = useLocation();
 // const { userName, userRole } = location.state || {};
  const navigate = useNavigate();
  const  userName =  localStorage.getItem('userName');
  const  userRole =  localStorage.getItem('role');

  useEffect(() => {
    //setUserLogin({ name:  userName, role:userRole});
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    const close = () => setShowProfileMenu(false);
      document.addEventListener("click", close);
      return () => document.removeEventListener("click", close);
      
    const testInterval = setInterval(() => {
      testApplication();
    }, 1 * 60 * 1000); // 2700000 ms

   // testApplication();
    return () => clearInterval(interval);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = async () => {
    await logout();
    setUserLogin(null); // Clear authentication context
    navigate('/login'); // Redirect to the login page
  };

  const testApplication = async () => {
    try {
      const result = await testApp();
      console.log("Service Status: " + result);
    } catch (error) {
      console.error("Error occurred while testing the application:", error);
      // You can also display a user-friendly message here
      // Example: 
      // alert("There was an issue with the application. Please try again later.");
    }
  };
  

  // Prevent default behavior on anchor tag click
  const handleNavLinkClick = (e: React.MouseEvent, target: string) => {
    e.preventDefault();  // Prevent hash from appearing in the URL
    const element = document.getElementById(target);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} className="logo" alt="logo" />
        <div>AriseUpp7</div>
      </div>
      <div className="title-container">
        {images.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            className={`slideshow-media ${index === currentIndex ? 'active' : ''}`}
          />
        ))}
      </div>
      <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
        <ul>
          <li><Link to="/dashboard" className="auth-link">Home</Link></li>
          <li><a href="#about-us" onClick={(e) => handleNavLinkClick(e, 'about-us')}>About Us</a></li>
          <li><a href="#our-objectives" onClick={(e) => handleNavLinkClick(e, 'our-objectives')}>Our Objectives</a></li>
          <li><a href="#our-services" onClick={(e) => handleNavLinkClick(e, 'our-services')}>Our Services</a></li>
          <li><a href="#our-team" onClick={(e) => handleNavLinkClick(e, 'our-team')}>Our Team</a></li>
          {/*<li><a href="#success-stories" onClick={(e) => handleNavLinkClick(e, 'success-stories')}>Success Stories</a></li>*/}
          <li><a href="#contact-us" onClick={(e) => handleNavLinkClick(e, 'contact-us')}>Contact Us</a></li>
        </ul>
        <div className="user-info">
          {(user?.name || userName) && (
            <p>Welcome, {user?.name || userName}!</p>
          )}
        </div>
      </nav>
      <div className="auth-links">
        {userName ? (
          <div className="profile-wrapper">
            {/* User Avatar */}
            <div
              className="user-avatar"
              onClick={(e) => {
                e.stopPropagation();
                setShowProfileMenu((prev) => !prev);
              }}
            >
              {userName.charAt(0).toUpperCase()}
            </div>

            {/* Profile Dropdown */}
            {showProfileMenu && (
              <div
                className="profile-dropdown"
                onClick={(e) => e.stopPropagation()}
              >
                <UserProfile />
              </div>
            )}
          </div>
        ) : (
          <>
            <Link to="/join" className="auth-link joinus-link">Join Us</Link>
            &nbsp;|&nbsp;
            <Link to="/login" className="auth-link">Login</Link>
          </>
        )}
      </div>

      <div className="menu-toggle" onClick={toggleMenu}>
        &#9776; {/* Hamburger icon */}
      </div>
    </header>
  );
};

export default Header;
